import { combineReducers } from '@reduxjs/toolkit';

import programReducer from './programReducer';
import menuSidebarReducer from './menuSidebar/menuSidebarSlice';
import createProgramReducer from './createProgram/createProgramSlice';
import structureProgramReducer from './structureProgram/structureProgramSlice';
import structureBonusReducer from './structureBonus/structureBonusSlice';

import structureDesign from './structureDesign/StructureDesignSlice';

import publishProgramReducer from './publishProgram/publishProgramSlice';
import pushMessage from './pushMessage/PushMessageSlice';
import orderProgramReducer from './orderProgram/orderProgramSlice';

export default combineReducers({
  programs: programReducer,
  createProgram: createProgramReducer,
  structureProgram: structureProgramReducer,
  structureBonus: structureBonusReducer,
  structureDesign: structureDesign,
  orderProgram: orderProgramReducer,
  publishProgram: publishProgramReducer,
  pushMessage: pushMessage,
  menuSidebar: menuSidebarReducer,
});
